import React, { useEffect, useMemo, useState } from 'react';
import { RegionAndLanguageSelectType } from '../../types';
import LogicSelect from '../LogicSelect';
import LanguageSelect from '../LanguageSelect';
import RegionSelect from '../RegionSelect';
import './index.scss';
import BubbleCommon, {
  influencerRegionFilterTips,
  influencerLanguageFilterTips,
  languageFilterTips,
  regionFilterTips,
  TipsMapType,
} from '../../../BubbleCommon';
import { compareArraysEqual } from '../../utils';
import { useStateRef } from '@op/hooks/common';
import { useIntl } from 'umi';

const regionTipsMap: { common: TipsMapType; influencer: TipsMapType } = {
  common: regionFilterTips,
  influencer: influencerRegionFilterTips,
};

const languageTipsMap: { common: TipsMapType; influencer: TipsMapType } = {
  common: languageFilterTips,
  influencer: influencerLanguageFilterTips,
};

export default function RegionAndLanguageSelect({
  regionTipsKey = 'common',
  languageTipsKey = 'common',
  collectionCallback,
  filterValue,
  toggleLanguage = true,
  ...props
}: RegionAndLanguageSelectType) {
  const { formatMessage } = useIntl();
  const [languageRef, language, setLanguage] =
    useStateRef<Array<string> | null>(null);

  const localFilterValue = useMemo(() => {
    if (language !== null) {
      return { ...filterValue, language };
    }

    return filterValue;
  }, [language, filterValue]);

  useEffect(() => {
    collectionCallback?.(
      'RegionAndLanguage',
      (value: any) => {
        if (
          !compareArraysEqual(
            languageRef.current || [],
            value?.language || [],
          ) &&
          toggleLanguage
        ) {
          setLanguage(value.language);
        }
      },
      ['language'],
    );
  }, []);

  return (
    <div className="region-and-languageSelect-select-wrapper">
      <BubbleCommon
        placement="top"
        tipsMap={languageTipsMap[languageTipsKey]}
        showIcon={false}
      >
        <LanguageSelect
          {...props}
          filterValue={localFilterValue}
          collectionCallback={collectionCallback}
          disabled={toggleLanguage}
        />
      </BubbleCommon>
      <LogicSelect
        {...props}
        filterValue={filterValue}
        defaultKey="logic"
      ></LogicSelect>
      <BubbleCommon
        placement="top"
        tipsMap={regionTipsMap[regionTipsKey]}
        showIcon={false}
      >
        <RegionSelect
          {...props}
          filterValue={filterValue}
          collectionCallback={collectionCallback}
          showTips={false}
        ></RegionSelect>
      </BubbleCommon>
      {toggleLanguage && (
        <p className="dbo-disabled-tips">
          {formatMessage({
            id: 'We recommend language filter. Region filter only fits some official accounts and creators.',
          })}
        </p>
      )}
    </div>
  );
}
